module.exports = {
  appName: 'Manufacturing execution management system',
  message: {
    title: 'System Info',
    error_factory_code_not_input: 'Please enter the factory code',
    error_employee_code_not_input: 'Please enter employee code',
    error_custom_code_not_input: 'Please enter the customer code',
    error_verify_code_not_input: 'Please fill in the verification code.',
    error_login_password_not_input: 'Please enter the login password',
    error_device_code_not_input: 'Please enter device code',
    error_info: "Error Indo",
    error_ajax: "Data request error, please refresh and try again!",
    error_not_login: "Please try again after login!",
    error_permission_validate: "You do not have the right to perform the current operation!",
    error_can_empty: "The current item can't be empty!",
    error_opera_retry: "The operation failed, please try again!",
    timeout: "Connection timeout, please try again!",
    error_sysdate_can_not_execute_current_opera: "System data cannot perform this operation!",
    error_can_not_delete_because_used: "The current data is in use and cannot be deleted!",
    error_code_same_pleas_change: "Duplicate code, please confirm!",
    has_children_can_not_delete: "Subitems exist, cannot be deleted!",
    please_input_required_items: "Please input required items!",
    please_select_row_to_opera: 'Please select the data to be operated',
    please_check_row_to_opera: 'Please check the data you want to operate.',
    can_not_delete_system_data: 'System data cannot be deleted',
    error_404: 'The page you visited does not exist',
    error_403: 'You do not have permission to access the current page',
    error_go_back: 'Return to previous page',
    error_go_login: 'Return to login',
    Employee_Code_does_not_exist: 'Employee Code [%1] does not exist',
    Device_code_does_not_exist: 'Device code [% 1] does not exist',
    Craft_code_does_not_exist: 'Craft code [% 1] does not exist',
    please_select_part_to_opera: 'Please select the parts to be operated on.',
    please_select_process_to_opera: 'Please select the process to be operated on.',
    old_password_error: 'Original password error',
    confirm_delete_data: 'Are you sure you want to delete the selected data?',
    error_param_validate: 'Parametric verification failed, please confirm whether illegal access!'
  },
  login: {
    login: 'Sign in',
    remember: 'Remember password',
    verify_code: 'Verification Code'
  },
  nav: {
    produce_order: "work order",
    project_manage: 'Project',
    process_manage: "process",
    progress_query: "Progress query",
    report: "reporting",
    quality_manage: "Quality",
    quality_determine: "qualityDetermine",
    quality_penalty: "qualityPenalty",
    quality_recall: "quality Recall",
    system_setting: "System",
    modify_password: "Modify Password",
    personal_center: "Personal Center",
    exit_system: "Exit System",
    plan: "Plan",
    forms: 'Report form',
    basic_data: {
      title: "basic data",
      factory_setting: "Factory setting",
      department_manage: "Department management",
      role_manage: "Role management",
      employee_manage: "Employee management",
      device_manage: "device management",
      operation_manage: "Operation management",
      production_line_manage: "Production line management",
      cost_type_manage: "Cost type management",
      shelf_manage: "Shelf management",
      work_group_manage: 'work group management',
      software_download: 'Software download'
    },
    classify_setting: {
      title: "Classify setting",
      product_type: "product type",
      order_type: "Order type",
      part_classify: "Parts classification",
      error_classify: 'Error classification',
      project_classify: 'Project classification'
    },
    job_deployment: "Job deployment",
    standard_process_library: "Standard process library",
    custom_column: "Custom column",
    log_manage: "Log",
    approval_process: 'Approval process',
    class_table_setting: 'class table setting',
    holiday_setting: 'Holiday setting',
    offline_file_setting: 'Offline File Settings',
    standard_procedure_setting: 'procedure setting',
    project_master_plan: 'Master Plan',
    project_master_plan_template_setting: 'Master Plan Template Setting',
    customer_form: 'Customer Form'
  },
  common: {
    opera: 'operation',
    open: 'open',
    upload: 'upload',
    file: 'file',
    setting: 'setting',
    factoryCode: 'Factory Code',
    employeeCode: 'Employee Code',
    LoginPassword: 'Login Password',
    add_user: 'Add User',
    add_time: 'Add Time',
    update_user: 'Update User',
    update_time: 'Update Time',
    add: "Add",
    save: "save",
    saveAndAdd: "Save and continue to add",
    reset: "reset",
    cancel: "cancel",
    delete: "delete",
    edit: "edit",
    query: "query",
    img_is_not_upload: "Picture not uploaded",
    confirm: "confirm",
    filter: "filter",
    please_input_filter_content: "Please enter the filter content.",
    default_value_setting: "Default settings",
    name: 'Name',
    remark: 'Remark',
    display: 'display',
    hide: 'hide',
    move: 'move',
    copy: 'copy',
    see: 'See',
    split: 'Split',
    more: 'More',
    approved: 'Approved',
    approval_status: 'Approval status',
    approval_sponsor: 'Approval sponsor',
    approver: 'Approver',
    approval_approval: 'Approval approval',
    approval_return: 'Approval return',
    ongoing: 'ongoing',
    opera_type: 'Opera type',
    code: 'Code',
    capacity: 'capacity',
    select_department: 'Select department',
    select_resources: 'Select resources',
    craft: 'Craft',
    production_line: 'Production line',
    status: 'state',
    today: 'today',
    import_start_row: 'Start line',
    select_craft: 'Selection of crafts',
    amount: 'Amount',
    paste: 'paste',
    close_copy_model: 'Exit replication mode',
    reset_cache: 'Reset Browser Cache'
  },
  password: {
    original_password: 'Original password',
    new_password: 'New password',
    confirm_password: 'Confirm the password',
    error_please_input_original_password: "Please enter the original password",
    error_please_input_new_password: "Please enter the new password",
    error_please_input_confirm_password: "Please enter the confirmation password",
    error_please_input_password_not_same: "Two inputted password inconsistencies",
    default_password_tip: "Employee default password: 123456",
    reset_password: 'reset password',
    password_is_reset: "The password reset is successful, the new password is: 123456"
  },
  status: {
    scrap: 'Scrap',
    normal: 'Normal',
    repair: 'Repair'
  },
  basic_data: {
    nav_width: '260px',
    role_manage: {
      role_name: "Role name",
      used_count: "Number of use",
      role_type: "Role type",
      role_permissions: "Role permissions",
      system_role: "System role",
      custom_role: "Custom roles"
    },
    department_manage: {
      Superior_department: 'Superior department',
      Department_code: 'Department code',
      Department_name: 'Department name',
      work_condition: 'working condition',
      work_status_on: 'Enable',
      work_status_off: 'Discontinuation',
      add_sub_department: 'Add sub departments',
      add_brother_department: 'Add the same level Department'
    },
    employee_manage: {
      status_on_the_job: 'On the job',
      status_vacation: 'Vacation',
      status_quit: 'Quit',
      employee_code: 'Employee code',
      employee_name: 'Employee name',
      employee_role: 'Employee role',
      subordinate_department: 'department',
      department_establishment_number: 'Department org. num',
      working_condition: 'working condition',
      normal_production_capacity: 'Normal production capacity',
      budgetary_capacity: 'Budgetary capacity',
      id_number: 'ID number',
      departmental_role: 'Departmental role',
      department_staff: 'Department staff',
      department_head: 'Department head',
      phone_number: 'Phone number',
      email: 'email',
      user_code_same: 'Employee Code Repetition!'
    },
    device_manage: {
      working_condition: 'working condition',
      device_code: 'Device code',
      device_name: 'Device name',
      equipment_brand: 'Equipment brand',
      producing_area: 'Producing area',
      Normal_capacity: 'Normal capacity',
      Maximum_capacity: 'Maximum capacity',
      Budget_capacity: 'Budget capacity'
    },
    cost_type_manage: {
      cost_type: "Cost type",
      cost_type_code: "Cost type code",
      cost_type_name: "Cost type name",
      parent_cost_type_code: "Parent cost type code",
      parent_cost_type_name: "Parent cost type name",
      edit_parent_cost_type: 'Edit parent cost type',
      edit_sub_cost_type: 'Edit sub cost type'
    },
    operation_manage: {
      manual_operation: 'Manual technology',
      automatic_process: 'Automatic technology',
      subsidiary_process: 'Subsidiary technology',
      outside_the_plan: 'Outside plan technology',
      procurement_process: 'Procurement technology',
      outside_process: 'Outside technology',
      internal_process: 'Inside technology',
      project_process: 'Project process',
      process_coding: 'Technology code',
      process_name: 'Technology name',
      process_attributes: 'Technology attributes',
      process_type: 'Technology type',
      conversion_process: 'Conversion technology',
      clamping_procedure: 'Clamping technology',
      report_way: 'Report way',
      scheduling_attributes: 'Scheduling attributes',
      cost_type: 'Cost type',
      default_preparation_time: 'preparation st',
      default_device_hours: 'device st',
      default_manpower_hours: 'manpower st',
      according_to_production_parameters: 'According to production parameters',
      ordinary: "ordinary",
      according_to_materiel_out_of_stock_code: 'by materiel out of stock code',
      allowable_excess_capacity: 'Allowable excess capacity',
      prohibition_excess_capacity: 'Prohibition excess capacity',
      default_part_size: 'Default part size',
      large_part_size: 'Large part',
      medium_part_size: 'Medium part',
      small_part_size: 'Small part',
      default_transfer_time: 'Transfer time',
      default_preset_days: 'Preset days',
      general_parts: 'General parts',
      core_parts: 'Core part',
      material_retrieval_code: 'material retrieval code',
      bar_code_content: 'Bar code content'
    },
    production_line_manage: {
      production_line_code: 'production line code',
      production_line_name: 'production line name'
    },
    shelf_manage: {
      shelf_code: 'Shelf code',
      shelf_name: 'Shelf name',
      shelf_remark: 'Shelf remark'
    },
    custom_manage: {
      title: 'customer manage',
      custom_code: 'Customer Coding',
      custom_name: 'Customer Abbreviation',
      custom_full_name: 'Customer full name',
      custom_address: 'address',
      custom_area: 'region',
      custom_tel: 'Telephone',
      custom_fax: 'Fax',
      custom_mail: 'e-mail'
    }
  },
  job_deployment: {
    operation_group: 'Operation group',
    administrative_department: 'Administrative department',
    operation_group_coding: 'Operation group coding',
    name_of_operation_group: 'Name of operation group',
    normal_production_capacity: 'Normal production capacity',
    maximum_capacity: 'Maximum capacity',
    association_process: 'Association process',
    associated_production_line: 'Associated production line',
    associated_resources: 'resources',
    resource_type: 'Resource type',
    resource_coding: 'Resource coding',
    resource_name: 'Resource name',
    staff: 'staff',
    equipment: 'equipment',
    shelves: 'Goods shelves',
    work_attributes: 'Work attributes',
    job_level: 'Job level',
    partTime_productivity: 'Part-time productivity',
    fullTime: 'Full-time',
    partTime_job: 'Part-time job',
    downtime: 'Downtime',
    apprentice: 'Apprentice',
    primary: 'primary',
    intermediate: 'intermediate',
    senior: 'senior',
    expert: 'expert',
    group_resources_delete_intercept: 'Selected resources, some resources have been allocated to the craft, can not be deleted!',
    craft_resources: 'craft resources'
  },
  custom_column: {
    integer: 'integer',
    decimal: 'decimal',
    text: 'Text (less than 500 words)',
    date: 'date',
    column_type: 'Column type',
    system_definition_column: 'System definition column',
    upper_shift: 'Upper shift',
    down_shift: 'Down shift',
    employee_selection: 'Employee selection',
    device_selection: 'Device selection',
    show_in_table: 'Show in table',
    hide_in_table: 'Hide in table',
    img: 'picture',
    column_width: 'width/ps',
    column_attribute: 'attribute'
  },
  produce_order: {
    diagram: 'diagram',
    order_area: 'Work list area',
    processing_order: 'Processing work list',
    completion_order: 'Completed work list',
    area_name: 'Area name',
    can_report: 'can report',
    can_schedule: 'can schedule',
    add_sub_area: 'add sub area',
    add_brother_area: 'add brother area',
    internal_part_only: 'Internal parts only',
    internal_and_external_part: 'Internal and external parts',
    lock_plan: 'Lock plan',
    not_locked: 'Not locked',
    production_work_order: 'production work order',
    rate_of_progress: 'Rate',
    delay_days: 'Delay',
    copy_order_plan: 'copy order plan',
    copy_part_and_process: 'copy part and process',
    copy_try_count: 'copy try count',
    target_try_count: 'target try count',
    order_attribute: 'order attribute',
    plan_attribute: 'plan attribute',
    product_attribute: 'product attribute',
    customer_attribute: 'customer attribute',
    calling_bom: 'calling bom',
    can_automatic: 'can automatic'
  },
  produce_part: {
    part_list_title: 'Parts list',
    part_select_all: 'All',
    part_un_select: 'Invert',
    part_attribute_default: 'All',
    part_attribute_part: 'Parts',
    part_attribute_sub: 'Accessory parts',
    part_attribute_design: 'Design parts',
    part_attribute_assemble: 'Assemble parts',
    part_attribute_debug: 'Debug: parts',
    produce_part_split: "Parts segmentation",
    part_split_error_message: "The number of manual inputs exceeds the total number. Please re-enter!",
    part_code_exist: '【%1】 already exists',
    part_delete_tips: 'The encoding already exists. This operation will delete the selected 【%1】 data. Do you want to continue?',
    part_copy_tips: 'This operation will copy the selected 【%1】 data. Do you want to continue?',
    emergency_order: 'Emergency insert',
    emergency_order_cancel: 'Cancel the insert',
    emergency_order_confirm: 'Are you sure you want to execute emergency inserts?',
    emergency_order_icon: 'Insert sheet'
  },
  produce_part_sub_list: {
    part_sub_list_title: 'List of accessory parts',
    part_sub_list_column_orderIndex: 'Order',
    part_sub_list_column_file: 'AP Process Technical Document',
    part_sub_list_choose_title: 'Select the list of accessory parts',
    part_sub_list_selected: 'Check list',
  },
  produce_process: {
    process: 'process',
    process_list: 'processes',
    produce_process_split: "Process segmentation",
    please_input_required_split_num: "Please enter the number of partitions",
    process_split_num: "Split quantity",
    process_split_st: "Split man hour",
    part_card: "Part card",
    process_card: "Process card",
    same_crafts_card: "Same card",
    process_achievement: "Details of achievement",
    process_state_un_start: "Not yet begun",
    process_state_processing: "Processing",
    process_state_completed: "Completed",
    process_state_suspended: "Pause",
    process_state_scrapped: "Scrap",
    process_state_purchase: "Special mining",
    process_state_received: "Receive",
    process_state_part_received: "Partial reception",
    process_state_un_completed: "Unfinished",
    appoint_time_tips: 'The start time cannot be greater than the end time!'
  },
  process_library: {
    standard_order: "Standard order",
    template_no: "Template coding",
    template_name: "Template name",
    template_attribute: "Attribute",
    template_attribute_craft: "craft",
    import_part_process: "Import parts and processes",
    import_part: "Import parts",
    import_process: "Import parts",
    template_not_empty: "Template encoding or template name cannot be empty!"
  },
  approval_process: {
    Approval_type: 'Approval_type',
    Associated_data: 'Associated_data',
    Approval_add: 'Approval_add',
    Approval_modification: 'Approval_modification',
    Approval_deletion: 'Approval_deletion',
    Process_name: 'Process_name',
    Process_notes: 'Process_notes',
    Approval_process: 'Approval_process',
    Reporting_time: 'Reporting_time/H',
    Approval_intercept: 'Approval intercept',
    Departmental_approval: "approval by departments",
    superior_departments_approval: "approval by superior departments",
    custom_approval: "Custom process",
    All_approval: "All approval",
    All_data_will_be_approved: "All data will be approved.",
    Approval_by_order_type: "Approval according to type of work order",
    Data_specifying_only_the_type_of_work_order: "Data specifying only the type of work order",
    Approval_by_product_type: "Approval by product type",
    Data_that_specifies_only_product_types: "Data that specifies only product types",
    please_select_approval_process: 'Please select the approval process.'
  },
  approval_process_setting: {
    add_root_node: 'Add Approval Node',
    auditor: 'Auditor'
  },
  report: {
    report_type: 'report type',
    report_receive: 'Receive',
    report_start: 'Start',
    report_unfinished: 'Unfinished',
    report_finished: 'Finish',
    report_outside: 'Outside the plan',
    report_bar_code: 'report bar code',
    report_single_person: 'Single newspaper worker',
    report_many_people: 'Multiplayer newspaper',
    report_part_schedule: 'Part progress',
    report_record: 'Record of work report',
    report_source: 'Report source',
    view_work_reporting_barcode: 'View work reporting barcode',
    appoint_resource_code: 'appoint resource code',
    appoint_resource_name: 'appoint resource name',
    previous_process: 'previous process',
    next_process: 'next process',
    operation_user: 'Actual operator',
    scan_barcode: 'Scan barcode or not',
    code_type: 'Barcode Type',
    qr_code: 'bar code',
    packet_number: 'Packet number',
    finished_quantity_cannot_be_less_than: 'Finished quantity cannot be less than 0.01',
    the_start_quantity_cannot_be_greater_than_the_machinable_quantity: 'The start quantity cannot be greater than the machinable quantity',
    batch_requisition_can_only_be_executed_under_the_same_processing_condition: 'Batch requisition can only be executed under the same processing condition',
    same_process_can_be_applied_for_batch_work: 'The same process can be applied for batch work.',
    barcode_already_exists: 'Barcode already exists',
    barcode_format_is_wrong: 'Barcode format is wrong',
    are_you_sure_you_want_to_perform_operations_on_processes: 'Are you sure you want to perform [$2] operations on [$1] processes?',
    selected_process_exists_already_started_process: 'Selected process exists already started process! uuuuuuuuuuuu',
    tips_for_multiple_workers: 'The current task is completed by more than one person. You need to report unfinished and enter the actual completed quantity or completion rate of the individual]',
    There_is_an_unacceptable_process_in_the_selected_process: 'There is an unacceptable process in the selected process!',
    No_finished_quantity_in_the_previous_process: 'There is no finished quantity in the previous operation in the selected operation. It cannot be received!',
    There_is_no_starting_process_in_the_selected_process: 'There is no starting process in the selected process!',
    batch_operation_not_supported_finish: 'At present, the batch operation is not supported by the applicant. Please select the applicant separately. If the batch process starts, the batch operation will be automatically executed.',
    confirm_batch_report_finish: 'The current process starts in batches. Are there other processes that operate in batches at the same time?',
    Batch_reporting: 'Batch reporting',
    Unpacking: 'Unpacking',
    Batch_start: 'Batch start',
    Batch_completion: 'Batch completion',
    Unfinished_batch: 'Unfinished batch',
    Batch_reception: 'Batch reception',
    report_info_setting: 'Report Information Settings',
    send_remark: 'Handover instruction',
    receive_num: 'Receive number',
    send_user: 'Sender',
    message_please_select_resources_for_insert: 'Please select $1 ',
    mach_num: 'mach number',
    finish_num: 'finish number',
    mach_user: 'mach user',
    mach_device: 'mach device',
    completion_rate: 'completion rate',
    confirm_batch_finish: 'Will the selected process and the batch start process be completed and executed?',
    confirm_batch_un_finish: 'Unfinished operation will be carried out on the selected process and its batch start process. The number of unfinished batches and the completion rate are all 0. Do you confirm the execution?',
    process_is_not_existence: 'The process does not exist!',
    process_can_not_report: 'This process can\'t be report!',
    process_is_existence_to_select: 'The process exists to select the process',
    process_can_mach_num_is_zero: 'Selected process can be maching number is 0!',
    previous_process_is_not_finish: 'The previous process is not completed, and the current process can not start! ',
    has_previous_process_not_finish_process: 'In the selected process, there is an incomplete process in the previous process, which can not start!',
    total_st: 'total st',
    finish_st: 'finish st',
    process_can_not_add_report_detail: 'There is no number to report in current process, so it can\'t be add to the process! ',
    report_by_param_can_not_batch_report: 'According to the production parameters of the work process, can not batch report!',
    report_by_material_out_barcode_can_not_batch_report: 'According to the barcode of material discharged from warehouse, batch reporting can not be carried out! ',
    please_input_material_out_barcode: 'Please enter barcode for material discharging from warehouse!',
    finish_ratio: 'Finish rate',
    current_finish_ratio: 'This completion rate',
    can_not_report_un_finish_return_to_finish: 'Complete all processing, please report completion!',
    has_package_process_single_report: 'There is a packaging process, whether to unpack and report to the workers?',
    pack_process_list: 'Packaging process list',
    pack_single_report: 'Dismantling and Report',
    part_technical_file: 'Parts Technical Documents',
    process_technical_file: 'Process Technical Documents',
    max_hour: 'Min. not less than 1 minute, max. not more than 24 hours',
    report_deplane: 'Finish',
    report_operate_a_computer: 'Start',
    start_num: 'Starting quantity',
    error_num: 'Bad quantity',
    problem_classification: 'Problem classification',
    problem_description: 'Problem description',
    please_input_start_num: 'Please enter the starting quantity',
    report_material_code: 'Material bar code',
    mat_code_can_not_repeat: 'Barcode cannot be repeated',
    mat_code_not_null: 'Barcode cannot be empty',
    process_finish: 'The current work reporting record of the operation has been processed. Please complete the operation',
    batch_number: 'Job lot No',
    file_size_error: 'File size cannot exceed 5m',
    finish_num_max_error: 'The maximum completed quantity cannot be greater than the reported quantity',
    error_not_set_mrp:'Please set MR of operation first',
    time_interval:'Time interval',
    anomaly_classification:'Anomaly classification',
    abnormal_quality:'Abnormal quality',
    abnormal_production_line:'Abnormal production line',
    abnormal_plan:'Plan exception',
    mould_status:'Mould status',
    finish_tips:'Prompt: if the task is not completed, please enter the completed quantity, otherwise, it will be completed by default'
  },
  class_table_setting: {
    Employee_class_table: 'Employee class table',
    Equipment_class_table: 'Device class table',
    Holiday_setting: 'Holiday setting',
    Factory_holiday: 'Factory holiday',
    Employee_holiday: 'Employee holiday',
    set_month: 'setting month',
    class_table: 'class table',
    detail: 'detail',
    start_time: 'start time',
    end_time: 'end time',
    to_be_on_duty: 'To be on duty',
    rest: 'rest',
    interrupt: 'interrupt',
  },
  progress: {
    show_finished_parts: 'finished parts',
    show_plan_time: 'plan time',
    show_actual_time: 'actual time',
    show_standard_st: 'standard st',
    show_actual_st: 'actual st',
    show_craft_name: 'craft name',
    show_finish_day: 'show craft name',
    out_of_parts: 'out of parts',
    combined_processing: 'combined processing',
    process_synchronization: 'process synchronization',
    composite_relations_View: 'composite relations',
    parts_filter: 'parts filter',
    add_sync: 'Add sync',
    sync_record: 'Sync Record',
    start_date: 'Start date',
    end_date: 'End date',
    outgoing_process: 'Outside process',
    outgoing_num: 'Outside num',
    outgoing_date: 'Outgoing date',
    pre_parts: 'Pre-Parts',
    pre_process: 'Pre-process',
    rear_parts: 'Rear Parts',
    postprocess: 'Postprocess',
    combination_type: 'Combination type',
    process_combination: 'Process combination',
    part_assembly: 'Part combination',
    message_The_current_process_exists_please_do_not_add_it_again: 'The current process exists, please do not add it again!',
    message_Can_not_assemble_the_same_parts: 'Can not assemble the same parts!',
    message_The_number_of_adding_processes_on_this_side_has_reached_the_maximum: 'The number of adding processes on this side has reached the maximum!',
    message_The_current_process_has_been_the_process_of_external_collaboration: 'The current process has been the process of external collaboration!',
    message_The_current_process_processing_status_does_not_allow_outsourcing: 'The current process processing status does not allow outsourcing!',
    message_The_process_code_of_synchronous_process_must_be_the_same: 'The process code of synchronous process must be the same!',
    pack_type: 'Packing type',
    pack_type_same_order: 'Packing of same order',
    pack_type_more_order: 'Packing of cross order'
  },
  holiday_setting: {
    factory_holiday_setting: "Factory Holiday Settings",
    monday: 'M',
    tuesday: 'T',
    wednesday: 'W',
    thursday: 'T',
    friday: 'F',
    saturday: 'S',
    sunday: 'S',
    factory_holiday: 'Factory holiday',
    user_overtime: 'Overtime work',
    user_holiday: 'Employee holiday',
    user_holiday_tip: 'If the set date is a factory holiday, the status is employees working overtime.'
  },
  offline_file_setting: {
    file_describe: "File description",
    storage_type: "Storage type",
    file_format: "file format",
    classify_name: 'Classify Name',
    respective_region: "Respective region",
    storage_type_local: "Local file",
    storage_type_ftp: "FTP file",
    storage_type_sftp: "SFTP file",
    respective_region_project: 'Project file',
    respective_region_order: "Worksheet file",
    respective_region_part: "Parts file",
    respective_region_process: "Process documents",
    start_path: "Start path",
    server_host: "Server IP",
    server_port: "Server Port",
    server_user_name: "User account",
    server_user_password: "Login password",
    label_width: "130px",
    file_path: "File path",
    add_fuzzy_path: "Adding Fuzzy Path",
    add_fuzzy_path_confirm: "After adding the blurred path, file upload is not supported. Manual operation is needed. Are you sure to continue?",
    error_add_path: "Please set the path",
    file_classify: "file classify",
    classify_setting: 'file classify setting'
  },
  standard_procedure_setting: {
    title: 'Title',
    width: 'width',
    table: 'form',
    table_setting: 'Table setting',
    production_params: 'Production parameters',
    add_plan_row: 'Add plan parameters',
    add_real_row: 'Add actual parameters',
    device_operating_params: 'Operating parameters of device',
    show_line_number: 'set number',
    show_row_number: 'Display row number',
    comparison_table: 'Comparison form',
    comparison_table_setting: 'Compare table settings',
    comparison_mode: 'Comparison mode',
    comparison_mode_1: 'Lateral alignment',
    comparison_mode_2: 'Vertical alignment',
    reference_column: 'Reference Column Name',
    each_generation_reference_column: 'Generate reference columns for each comparison',
    comparison_column_number: 'Number of columns compared',
    comparison_column: 'Align column names',
    form: 'form',
    form_setting: 'Form setting',
    add_row: 'add rows',
    delete_row: 'Delete row',
    add_column: 'Add column',
    column_type: 'Column type',
    column_number: 'Column number',
    column_format: 'Column format',
    column_name: 'Column name',
    row_span: 'Spanning rows',
    column_span: 'Spanning column number',
    show_text: 'Display text',
    input_box: 'Input box',
    data_type: 'data type',
    double_reserved_points_prepend: 'Retain',
    double_reserved_points_append: 'Decimal point',
    year: 'year',
    month: 'month',
    day: 'day',
    hour: 'time',
    minute: 'branch',
    second: 'second',
    show_code: 'Display Coding',
    show_name: 'Display name',
    show_code_and_name: 'Display code and name',
    current_row_can_not_add_column: 'Current row cannot add columns!',
    filed_column: 'Column field'
  },
  produce_plan: {
    plan_versions: 'Planned version',
    import_title: 'Import',
    download_title: 'export',
    upload_title: 'Import plan',
    chooseFile: 'Select Files',
    uploadTip: 'Only upload xlsx/xls files, and no more than 50M!',
    plan_of_day_title: 'Team Day Plan',
    appoint_day_plan: "Setting Date Plan",
    cancel_day_plan: "Cancel day plan",
    produce_day_plan: "Daily Plan",
    non_existent: "Non-existent£¡",
    load_st: "Load working hours",
    modal_cloud_setting: "Modal Cloud Settings",
    middle_schedule: 'Mid-calendar',
    part_middle_schedule: 'Part Schedule',
    small_schedule: 'Small calendar',
    waiting_area: 'Waiting area',
    processing_area: 'Processing Zone',
    completion_area: 'Completion Zone',
    employee_performance: 'Employee Performance',
    produce_plan_load: 'Production load',
    stagnation_time: 'Stagnation_time',
    receive_time: '接收时间',
    start_time: '开始时间',
    end_time: '结束时间'
  },
  produce_plan_load: {
    produce_plan_load_st: 'Load working hours:',
    capacity_tip: 'Standard capacity',
    max_capacity_tip: 'Maximum capacity',
  },
  quality_manage: {
    execute_state: 'Execute state',
    operation: 'Operation',
    po_num: 'PO Number',
    delivery_note_num: 'Delivery note number',
    remedy_user: 'Remedy user',
    duty_process: 'Duty Process',
    find_process: 'Find process',
    remedy_time: 'Remedy time',
    wait_for_initiation: 'Waiting for initiation',
    remedies_will_signed: 'Remedies will be signed',
    remedial_measures_were_not_signed: 'Remedial measures were not signed',
    quality_tracing: 'Quality tracing',
    quality_traceability_signature_ing: 'Quality Traceability Signature',
    finished_process: 'Finished processing',
    cancelled: 'Cancelled',
    jointly_sign: 'jointly sign',
    remedial_measures: 'Remedial measures',
    person_liable: 'Person liable',
    find_people: 'Find people',
    quantity_of_rework: 'Quantity of rework',
    error_classification: 'Error classification',
    error_reason: 'Error reason',
    specific_quantity: 'Specific quantity',
    scrap_quantity: 'Scrap quantity',
    common_signer_settings: 'Common Signer Settings',
    initiating_countersign: 'Initiating countersign',
    unsigned_execution: 'Unsigned execution',
    counter_signer: 'Counter signer',
    countersignature_status: 'Countersignature status',
    countersigned_endorsement: 'Countersigned endorsement',
    countersignature_time: 'Countersignature time',
    abandonment: 'Abandonment',
    staff_coding: 'Staff coding',
    employee_name: 'Employee name',
    remedies_will_be_signed: 'Remedies will be signed',
    quality_traceability_signature: 'Quality Traceability Signature',
    selection_of_signers: 'Selection of signers',
    to: 'to',
    cancel_countersign: 'Cancel countersign',
    adopt: 'adopt',
    not_pass: 'Not pass',
    no_countersigned: 'No countersigned',
    label_width: '120px',
    loss_label_width: '170px',
    label_value_margin: '20px',
    please_select_responsible_process: 'Please select the responsible process',
    please_select_the_person_responsible: 'Please select the person responsible',
    please_select_the_discovery_process: 'Please select the discovery process',
    please_select_the_discoverer: 'Please select the discoverer',
    please_enter_the_quantity_of_rework: 'Please enter the quantity of rework',
    please_select_the_error_classification: 'Please select the error classification',
    please_enter_the_special_quantity: 'Please enter the special quantity',
    please_enter_the_amount_of_scrapped: 'Please enter the amount of scrapped',
    please_choose_the_way_to_deal_with_it: 'Please choose the way to deal with it',
    please_select_the_data_that_needs_to_be_signed: 'Please select the data that needs to be signed',
    successful_operation: 'Successful operation',
    penalty_charge: 'Penalty charge',
    amount_of_penalty: 'Amount of penalty',
    loss_of_working_hours: 'Loss of working hours(H)',
    loss_due_date: 'Loss due date',
    loss_of_material_cost: 'Loss of material cost',
    loss_of_manufacturing_costs: 'Loss of manufacturing costs',
    penalty_notes: 'Penalty notes',
    will_sign_back_history: 'Will sign back history',
    responsibility_judgement: 'Responsibility judgement',
    punished_person: 'Punished person',
    please_choose_the_person_to_be_punished: 'Please choose the person to be punished',
    quality_traceability_will_sign_back_records: 'Quality traceability will sign back records',
    will_sign_the_withdrawal_record: 'Will sign the withdrawal record',
    operator_coding: 'Operator Coding',
    operator_name: 'Operator name',
    operation_time: 'Operation time',
    details_of_withdrawal_records: 'Details of withdrawal records',
    coding_of_responsible_person: 'Coding of responsible person',
    name_of_responsible_person: 'Name of responsible person',
    responsible_human_type: 'Responsible Human Type',
    responsibility_ratio: 'Responsibility ratio',
    supplier: 'Supplier',
    factory_staff: 'Factory staff',
    supplier_staff: 'Supplier staff',
    general_factory_staff: 'General factory staff',
    adding_responsible_persons: 'Adding Responsible Persons',
    yes: 'yes',
    no: 'no',
    the_selected_signer_is_not_identical_with_the_actual_signer: 'The selected signer is not identical with the actual signer, so it is impossible to carry out the signature!',
    display_completed_items: 'Display completed items',
    delete_successfully: 'Delete successfully!',
    canceled_deletion: 'Canceled deletion',
    this_action_will_delete_the_selected: 'This action will delete the selected',
    an_exception_list_do_you_want_to_continue: 'individual an exception list. Do you want to continue?',
    only_canceled_data_can_be_deleted_the_current_selected_item_contains_other_states: 'Only canceled data can be deleted. The current selected item contains other states!',
    rework: 'rework',
    degrade: 'degrade',
    scrap: 'scrap',
    you_signed_up_and_can_participate_again: "You've signed up and can't participate again.",
    personnel: "personnel",
    number: "num",
    actual_technology_parameter: "Process parameters",
    indirect_material_cost: "Indirect material cost",
    problem_classification: 'problem Classification',
    problem_description: 'problem Description'
  },
  project_master_plan: {
    node_setting: 'Planning Node Setting',
    node_code: 'Node coding',
    node_name: 'Node name',
    node_type: 'Node type',
    production_node: 'Production node',
    purchase_node: 'Procurement node',
    ability: 'Ability H/D',
    max_ability: 'Maximum capacity H/D',
    node_cost_type: 'Planning Node-Cost Type',
    cost_type_part_classify: 'Cost Type-Part Classification',
    by_month: 'monthly',
    by_week: 'By week',
    by_day: 'By day',
    by_hours: 'By hour',
    plan: 'plan',
    estimated_st: 'Estimated working hours',
    related_node: 'Associated node',
    relation_type: 'Association type',
    postposition_days: 'Postposition days',
    plan_time: 'Planned date',
    plan_start_time: 'Planned start date',
    plan_end_time: 'Planned completion date',
    actual_st: 'Actual working hours',
    capacity_ratio: 'Capacity ratio',
    delivery_date: 'Delivery date',
    delivery_date_change_count: 'Number of changes',
    delay_days: 'Delay days',
    unit_price: 'Unit Price',
    force_time: 'Compulsory time interval',
    yes: 'yes',
    no: 'no',
    plan_node_select: 'Selecting Planning Nodes',
    relation_plan_start_time: 'Starting date of association plan',
    relation_plan_end_time: 'Relevant Plan Completion Date',
    move_down: 'down',
    move_up: 'upward',
    when_change_node_code: 'Modifying the node coding will result in recalculating the node processing schedule. This operation is time-consuming. Are you sure you want to perform the operation?',
    master_plan_number: 'Number of nodes',
    import_other_plan_node: 'import from production orders',
    node_is_used_can_not_change_type: 'Node type cannot be modified in use!'
  },
  project_master_plan_template_setting: {
    master_plan_template: 'Master Plan Template',
    template: 'Template',
    template_name: 'Template name',
    plan_node_list: 'Planning node list',
    import: 'Import',
    import_template: 'Import template',
    message_please_select_template_to_import: 'Select the template to import',
    confirm_import_template: 'Are you sure you want to import the planned nodes in the template [%1]?',
  },
  cas_login: {
    cas_login_message_authentication_failure: 'Authentication failed!',
    cas_login_message_employee_not_found: 'Authentication failed, no corresponding user was found!',
    cas_login_message_factory_not_found: 'Authentication failed, no corresponding factory was found!'
  },
  project_manage: {
    add_project: 'New projects',
    modify_project: 'Editing Project',
    add_sub_project: 'New subproject',
    save_and_add_subprojects: 'Save and add subproject',
    save_and_add_peer_projects: 'Save and add peer project',
    edit_project: 'edit',
    delete_project: 'delete',
    project_plan: 'project plan',
    add_produce_order: 'New Productive Work Order',
    add_project_order: 'New Project Work Order',
    parent_project_code: 'Superior project coding',
    project_classify: 'Project type',
    project_code: 'Item Coding',
    project_name: 'entry name',
    project_order_code: 'Project order code',
    custom: 'Customer',
    custom_code: 'Customer Coding',
    custom_name: 'Customer Name',
    end_custom: 'End Customer',
    end_custom_code: 'End Customer Code',
    end_custom_area: 'Terminal client area',
    project_leader: 'Person in charge',
    input_time: 'Entry time',
    delivery_time: 'Project due date',
    project_ratio: 'Speed of progress',
    project_amount: 'Project amount',
    budget_amount: 'Budget amount',
    receivable_amount: 'Amount receivable',
    unpaid_amount: 'Unpaid Receivable',
    paid_amount: 'amount paid',
    budget_manage: 'budget Manage',
    designated_responsible_person:'designated responsible person',
    no_responsible_person:'no responsible person'
  },
  download: {
    offLineTools: {
      title: 'MES offline AIDS',
      describe: 'It is used to import scheduling data and upload and open offline files (FTP, SFTP and local files are supported) in file management. If the automatic scheduling or file management module is used, the software must be downloaded for use. The software is a tray program, which runs automatically in the system tray after startup. It supports windows7, windows8 and windows10.',
      language: 'language',
      file_name: 'File name',
      size: 'Size',
      download: 'download'
    }
  },
  forms: {
    monitoring_platform: 'Monitoring platform',
    details_of_staff_daily: 'Details of Staff Daily',
    process_in_machining: 'Process in Machining',
    department: 'Department',
    export_config: 'Export settings',
    export_column_selector: 'Select the export columns',
    process_status: 'Process state',
    mach_status: 'Processing state',
    performance_total_amount: 'Actual amount',
    standard_total_amount: 'Standard amount',
    performance_summary: 'Performance summary report',
    actual_amount: 'Actual amount',
    standard_amount: 'Standard amount',
    abnormal_working_hours: 'Abnormal working hours',
    abnormal_cost: 'Abnormal cost',
    unplanned_hours: 'Unplanned work',
    unplanned_amount: 'Unplanned amount',
    rate_of_progress: 'Rate of progress',
    report_quality_department: "Report of quality",
    workshop_report: 'Report of workshop',
    quality_report: "Quality report",
    processing_mode: "Processing mode",
    quality_state: "Quality state",
    number_errors: "Number of errors",
    discovery_time: "Discovery Time",
    component_type: "Component type",
    parts_and_processes: "Parts&processes",
    discard_time: "Discard time",
    rework_time: "Rework time",
    standard_preparation_time: "Standard preparation time",
    standard_manpower_hours: "Standard man-hour",
    standard_device_hours: "Standard equipment time",
    performance_preparation_time: "Solid preparation time",
    performance_manpower_hours: "Actual human hours",
    performance_device_hours: "Actual equipment hours",
    outside_and_purchase_process: 'Outside and purchase process',
    details_of_cost_report: 'Cost Details Report',
    indirect_code: 'Indirect Code',
    indirect_date: 'Indirect Date',
    outside_the_plan: 'Outside the plan',
    inside_the_plan: 'Inside the plan',
    cost_report: 'Cost report',
    submit_cost_details: 'Subject cost reort',
    plan_amount: 'Planned amount',
    abnormal_amount: 'Abnormal amount',
    cost_type_manage_children: 'Children cost type',
    planned_cost: 'Planned cost',
    actual_cost: 'Actual cost',
    total_planned_hours: 'Total planned hours',
    total_actual_hours: 'Total actual hours',
    total_abnormal_hours: 'total abnormal hours',
    total_unplanned_hours: 'total unplanned hours',
    total_unplanned_cost: 'total unplanned cost',
    processing_cost: 'Processing cost',
    outside_process_cost: 'Outside process cost',
    procurement_cost: 'Procurement cost',
    quality_analysis_report: "Quality analysis report",
    error_type: "Error type",
    wrong_number: "Wrong number",
    responsible_team: "Responsible team",
    responsible_supplier: "Responsible supplier",
    statistical_histogram: " statistical histogram",
    quality_management_report: "Quality management report",
    part_and_process_schedule: 'Parts operation progress report',
    details_of_device_daily: 'Details of Device Daily',
    alert_of_staff_abnormal: 'alert of staff abnormal',
    processing_timeout: 'processing timeout',
    part_warehouse_status_analysis:'Schedule of parts',
    finish_num:'Completion of the number',
    inventory_num:'inventory num',
    not_inventory_num:'not inventory num',
    inventory_type:'inventory type',
    part_put_in_storage:'part put in storage',
    order_put_in_storage:'order put in storage',
    total_weight:'total weight',
    employee_salary_detail: 'employee salary detail',
    valuation_weight:"valuation weight",
    valuation_weight_total:"valuation weight total",
    process_money:"process money",
    valuation_method:"valuation method",
    fixed_salary:"fixed salary",
    overtime_money:"overtime money",
    overtime_hours:"overtime hours",
    total_wages:"total wages",
    share_cost_details:"share cost details",

  },
  recovery: {
    title: 'Delete data recovery',
    recovery: 'recovery',
    delete_user: 'Delete person',
    delete_time: 'Delete time',
    recovery_order: 'Are you sure you want to restore the selected [%1] piece of data?',
    recovery_mach: 'Are you sure you want to restore [%1] selected work reporting record? After restoration, the quantity and working hours of the corresponding work reporting need to be adjusted manually.'
  },
  customer_form: {}
};



// WEBPACK FOOTER //
// ./src/common/lang/en.js